import React, { Component } from 'react'
import { connect } from 'react-redux'
import { filter } from 'lodash'
import Select from 'react-select-plus'
import * as CONSTANTS from 'app/modules/rules/constants'
import { isConnectedTo } from 'app/modules/integrations/selectors'

import EmployeeFilter from './EmployeeFilter'
import MoneyRaisedFilter from './MoneyRaisedFilter'
import CompanyTagsFilter from './CompanyTagsFilter'
import MarketTagsFilter from './MarketTagsFilter'
import TechTagsFilter from './TechTagsFilter'
import HeadquartersGeoFilter from './HeadquartersGeoFilter'
import HeadquarterPostalCodeFilter from './HeadquarterPostalCodeFilter'
import AnnualRevenueFilter from './AnnualRevenueFilter'
import InputFilter from './InputFilter'
import SelectFilter from './SelectFilter'
import NumericalValuesFilter from './NumericalValuesFilter'

import DemandbaseAudienceFilter from './Demandbase/DemandbaseAudienceFilter'
import DemandbaseIndustryFilter from './Demandbase/DemandbaseIndustryFilter'
import DemandbaseSubIndustryFilter from './Demandbase/DemandbaseSubIndustryFilter'
import DemandbaseEmployeeRanges from 'constants/DemandbaseEmployeeRanges'
import DemandbaseRevenueRanges from 'constants/DemandbaseRevenueRanges'
import { getClearbitRevealContext } from 'app/modules/enrichment/clearbit/selectors'

const emptyFilter = {
  operator: null, 
  value: null
}

const mapToOptions = (values) => !!values ? values.map(value => { return { label: value, value } }) : []

class FirmographicFilter extends Component {

  constructor(props) {
    super(props)

    this.state = {
      fieldType: props.activeFilter.field,
      firmographicCondition: emptyFilter,
    }
  }

  onTypeSelect = (type) => {
    this.props.updateModel(type.value)
    this.setState({ fieldType: type.value, firmographicCondition: emptyFilter }, this.updateParent)
  }

  onUpdateCondition = (updatedCondition) => {
    this.setState({ firmographicCondition: updatedCondition }, this.updateParent)
  }

  updateParent = () => {
    const isValid = this.isValid()
    this.props.setPageValidity(isValid)
    if (isValid) {
      this.props.setActiveFilter({
        field: this.state.fieldType,
        operator: this.state.firmographicCondition.operator,
        value: this.state.firmographicCondition.value
      })
    }
  }

  isValid() {
    return (!!this.state.firmographicCondition.operator && !!this.state.firmographicCondition.value)
  }

  renderTypeSelect = () => {
    const { hasDemandbase, hasClearbitReveal } = this.props

    let types = [];

    if (hasClearbitReveal) {
      const clearbitOptions = filter(Object.keys(CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES), 
        (key) => CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES[key].includes('clearbit'))

      types = types.concat(clearbitOptions)
    }

    if (hasDemandbase) {
      const demandbaseOptions = filter(Object.keys(CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES), 
        (key) => CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES[key].includes('demandbase'))

      types = types.concat(demandbaseOptions)
    }

    const typeOptions = Object.values(types).map((type) => {
      return {
        value: CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES[type], 
        label: CONSTANTS.FIRMOGRAPHIC_FILTER_TYPE_LABELS[type]
      }
    })

    const selectOptions = {
      multi: false,
      autoFocus: false,
      options: typeOptions,
      onChange: this.onTypeSelect,
      clearable: false,
      searchable: false,
      value:  this.state.fieldType
    }

    return (
      <Select {...selectOptions} />
    )
  }

  renderTypeComponent() {
    const {
      EMPLOYEES,
      MONEY_RAISED,
      COMPANY_CATEGORIES,
      MARKET_CATEGORIES,
      TECH_TAGS,
      HEADQUARTERS_STATE,
      HEADQUARTERS_COUNTRY,
      HEADQUARTERS_POSTAL_CODE,
      REVENUE,
      DEMANDBASE_AUDIENCE,
      DEMANDBASE_MARKETING_ALIAS,
      DEMANDBASE_INDUSTRY,
      DEMANDBASE_SUB_INDUSTRY,
      DEMANDBASE_EMPLOYEE_COUNT,
      DEMANDBASE_EMPLOYEE_RANGE,
      DEMANDBASE_ANNUAL_SALES,
      DEMANDBASE_REVENUE_RANGE,
      DEMANDBASE_HEADQUARTERS_CITY,
      DEMANDBASE_HEADQUARTERS_STATE,
      DEMANDBASE_HEADQUARTERS_COUNTRY
     } = CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES
    const components = {
      [EMPLOYEES] : <EmployeeFilter {...this.props} onUpdateCondition={this.onUpdateCondition} />,
      [MONEY_RAISED] : <MoneyRaisedFilter {...this.props} onUpdateCondition={this.onUpdateCondition} />,
      [COMPANY_CATEGORIES]: <CompanyTagsFilter {...this.props} onUpdateCondition={this.onUpdateCondition} />,
      [MARKET_CATEGORIES]: <MarketTagsFilter {...this.props} onUpdateCondition={this.onUpdateCondition} />,
      [TECH_TAGS]: <TechTagsFilter {...this.props} onUpdateCondition={this.onUpdateCondition} />,
      [HEADQUARTERS_STATE]: <HeadquartersGeoFilter {...this.props} onUpdateCondition={this.onUpdateCondition} />,
      [HEADQUARTERS_COUNTRY]: <HeadquartersGeoFilter {...this.props} onUpdateCondition={this.onUpdateCondition} />,
      [HEADQUARTERS_POSTAL_CODE]: <HeadquarterPostalCodeFilter {...this.props} onUpdateCondition={this.onUpdateCondition} />,
      [REVENUE]: <AnnualRevenueFilter {...this.props} onUpdateCondition={this.onUpdateCondition} />,
      [DEMANDBASE_AUDIENCE]: <DemandbaseAudienceFilter {...this.props} onUpdateCondition={this.onUpdateCondition}/>,
      [DEMANDBASE_MARKETING_ALIAS]: <InputFilter {...this.props} onUpdateCondition={this.onUpdateCondition}/>,
      [DEMANDBASE_INDUSTRY]: <DemandbaseIndustryFilter {...this.props} onUpdateCondition={this.onUpdateCondition}/>,
      [DEMANDBASE_SUB_INDUSTRY]: <DemandbaseSubIndustryFilter {...this.props} onUpdateCondition={this.onUpdateCondition}/>,
      [DEMANDBASE_REVENUE_RANGE]: <SelectFilter options={mapToOptions(DemandbaseRevenueRanges)} {...this.props} onUpdateCondition={this.onUpdateCondition} creatable={true}/>,
      [DEMANDBASE_EMPLOYEE_RANGE]: <SelectFilter options={mapToOptions(DemandbaseEmployeeRanges)} {...this.props} onUpdateCondition={this.onUpdateCondition} creatable={true}/>,
      [DEMANDBASE_HEADQUARTERS_CITY]: <InputFilter {...this.props} onUpdateCondition={this.onUpdateCondition}/>,
      [DEMANDBASE_ANNUAL_SALES]: <NumericalValuesFilter {...this.props} onUpdateCondition={this.onUpdateCondition}/>,
      [DEMANDBASE_EMPLOYEE_COUNT]: <NumericalValuesFilter {...this.props} onUpdateCondition={this.onUpdateCondition}/>,
      [DEMANDBASE_HEADQUARTERS_STATE]: <HeadquartersGeoFilter {...this.props} onUpdateCondition={this.onUpdateCondition} />,
      [DEMANDBASE_HEADQUARTERS_COUNTRY]: <HeadquartersGeoFilter {...this.props} onUpdateCondition={this.onUpdateCondition} />,
    }
    return components[this.state.fieldType]
  }

  render() {
    return (
      <div className="rules-choice">
        <header>
          <h1>Choose a Firmographic</h1>
          <p>Match enriched data about your visitors like industry, company size, time zone etc. </p>
        </header>
        
        <div className="rules-editor-content">
          <div className="rules-choice-sidebar drift-form">
            { this.renderTypeSelect() }
          </div>
          
          <div className="rules-editor-selection">
            {this.renderTypeComponent()}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  hasDemandbase: (isConnectedTo(state, 'demandbase')),
  hasClearbitReveal: getClearbitRevealContext(state).leadRoutingReveal
})

export default connect(mapStateToProps, null)(FirmographicFilter)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/FirmographicFilter/index.js